<template>
  <Header/>
  <div class="img-container" style="margin: 40px 0;">
    <img alt="" class="img-container" src="../assets/images/201910260927085114.jpeg"/>
  </div>
  <div class="p_container mauto clearfix">
    <div class="p_left">
      <div class="sidebar" editok="online">
        <div class="sortnavt"><h3>新闻分类</h3></div>
        <ul class="sortnavul">
          <li class="sortnavli" v-for="(item, index) in navList" :key="index">
            <a :href="item.path" target="" class="sortnava">{{ item.label }}</a>
          </li>
        </ul>
      </div>
      <div class="clear">
      </div>
    </div>
    <div class="p_right" style="margin-left: 30px;">
      <div class="p_right1">
        <div class="title01" id="com_pmodule_news_list" editok="online">
          <ins class="ticon08"></ins>
          <h3>{{ domTitle }}</h3>
        </div>
        <div class="p_about">
          <div editok="online" class="content">
            <div id="xweb-ajax-div" class="xweb-ajaxdiv" style="display: block; left: 791.5px; top: 254px;">
              <ul class="n_n_list">
                <li v-for="(item, index) in listData" :key="index">
                  <a :href="'/#/detail?id=' + item.ID">
                    {{ item.post_title }}
                  </a>
                  <span>{{ item.post_date.split(' ')[0] }}</span>
                </li>
              </ul>
            </div>
          </div>
          <!-- 开始分页模块内容 -->
          <PageFen :currentPage="queryData.page" :showItemPerPage="8" :totalPage="queryData.total"
                   :callBack="_pageChange"
                   style="margin-top: 260px;"/>
        </div>
      </div>
    </div>
  </div>
  <Footer/>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import PageFen from "@/components/PageFen"
import http from "@/util/http"

export default {
  name: "ListPage",
  components: {PageFen, Footer, Header},
  data() {
    return {
      queryData: {
        parent: undefined,
        page: 1,
        total: 1
      },
      listData: [],
      domTitle: undefined,
      pageNow: 1,
      pageTotal: 30,
      navList: [
        {
          id: 0,
          pathName: 'home',
          select: true,
          path: '/',
          label: '首页'
        },
        {
          id: 1,
          pathName: 'guoNeiZiXun',
          select: false,
          path: '/#/guoNeiZiXun',
          label: '国内资讯'
        },
        {
          id: 2,
          pathName: 'guoWaiZiXun',
          select: false,
          path: '/#/guoWaiZiXun',
          label: '国外资讯'
        },
        {
          id: 3,
          pathName: 'zuiXinZiXun',
          select: false,
          path: '/#/zuiXinZiXun',
          label: '最新资讯'
        },
        {
          id: 4,
          pathName: 'hangYeZiXun',
          select: false,
          path: '/#/hangYeZiXun',
          label: '行业资讯'
        },
        {
          id: 5,
          pathName: 'shiShiXinWen',
          select: false,
          path: '/#/shiShiXinWen',
          label: '时事新闻'
        }
      ]
    }
  },
  mounted() {
    this._domTitle()
  },
  methods: {
    _pageChange(e) {
      this.queryData.page = e
      this._getList()
    },
    _domTitle() {
      const routeName = this.$route.name
      for (const i in this.navList) {
        if (this.navList[i].pathName === routeName) {
          this.domTitle = this.navList[i].label
          this.queryData.parent = this.navList[i].id
          break
        }
      }
      this._getList()
    },
    _getList() {
      http.get('listPage', {
        parent: this.queryData.parent,
        page: this.queryData.page
      })
          .then((res) => {
            if (res.data.status === 0) {
              this.listData = res.data.data.list
              this.queryData.total = res.data.data.pageTotal
            }
          })
    }
  }
}
</script>

<style scoped>
.img-container {
  width: 980px;
  height: auto;
  object-fit: fill;
}

a:hover {
  color: #00b4ac;
}

</style>